import {
  faCircle as faCircleLight,
  faCircleCheck as faCircleCheckLight,
  faShieldExclamation as faShieldExclamationLight,
  faEyeSlash,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { ROLES } from '../../../config/permissions/roles';
import { combine } from '../../../helpers/styles';
import { useJuror } from '../../../hooks/useAuth';
import { JUROR_GROUP_PHASES } from '../../../models/jurorGroup';
import { EVALUATION_STATUS } from '../../../models/submission';
import { matchRoles } from '../../../helpers/roles';
import StatusIcon from './statusIcon';
import styles from './styles.module.scss';

const StatusColumn = ({ submission, isAdminView, className }) => {
  const { role, juror, jurorGroup } = useJuror();
  const currentJurorEvaluation = submission.evaluations.find(
    (evaluation) => evaluation.jurorId === juror?.jurorId
  );

  const renderJurorIcon = (status) => {
    switch (true) {
      case status === EVALUATION_STATUS.toBeDecidedByChairperson:
        return (
          <div className={combine(styles.iconContainer, styles.grey)}>
            <FontAwesomeIcon
              icon={faShieldExclamationLight}
              className={styles.icon}
            />
          </div>
        );
      case status === EVALUATION_STATUS.decidedByChairperson:
        return (
          <div className={combine(styles.iconContainer, styles.petrol)}>
            <FontAwesomeIcon
              icon={faShieldExclamationLight}
              className={styles.icon}
            />
          </div>
        );
      case status === EVALUATION_STATUS.toBeDecided:
        return (
          <div className={combine(styles.iconContainer, styles.blue)}>
            <FontAwesomeIcon icon={faCircleLight} className={styles.icon} />
          </div>
        );
      case status === EVALUATION_STATUS.decided:
        return (
          <div className={combine(styles.iconContainer, styles.petrol)}>
            <FontAwesomeIcon
              icon={faCircleCheckLight}
              className={styles.icon}
            />
          </div>
        );
      default:
        return null;
    }
  };

  if (
    role === ROLES.juror &&
    jurorGroup?.jurorGroupPhase !== JUROR_GROUP_PHASES.discussionPhase
  ) {
    return (
      <div className={styles.statusContainer}>
        {renderJurorIcon(currentJurorEvaluation?.status)}
      </div>
    );
  }

  return (
    <div
      className={combine(styles.statusContainer, className)}
      onClick={(e) => e.stopPropagation()}
    >
      {submission.evaluations
        .filter(
          (evaluation) =>
            !matchRoles(evaluation.role, [ROLES.chairPerson, ROLES.staff])
        )
        .map((evaluation) => {
          const isEvaluationByChairperson =
            evaluation.status === EVALUATION_STATUS.toBeDecidedByChairperson ||
            evaluation.status === EVALUATION_STATUS.decidedByChairperson;
          const isPersonalEvaluation = juror?.jurorId === evaluation.jurorId;
          const hidePoints = isEvaluationByChairperson && isPersonalEvaluation;

          return (
            <div
              key={evaluation.jurorId}
              className={combine(
                styles.statusItem,
                submission?.jurorId == evaluation?.jurorId &&
                  styles.highlightImpersonation
              )}
            >
              <div className={styles.rightAligned}>
                <StatusIcon
                  score={evaluation.totalPoints}
                  status={evaluation.status}
                  hasZeroValues={evaluation.hasZeroValues}
                />
                <span className={styles.link}>
                  {evaluation.firstname} {evaluation.lastname}
                </span>
              </div>
              {hidePoints ? (
                <FontAwesomeIcon
                  icon={faEyeSlash}
                  className={styles.hiddenIcon}
                />
              ) : (
                <span className={styles.points}>
                  {(!isAdminView && evaluation?.totalPoints) || 0}
                </span>
              )}
            </div>
          );
        })}
    </div>
  );
};

StatusColumn.propTypes = {
  submission: PropTypes.object,
  isAdminView: PropTypes.bool,
  onNameClick: PropTypes.func,
};

StatusColumn.defaultProps = {
  submission: {},
  isAdminView: false,
  onNameClick: () => {},
};

export default StatusColumn;
